module.exports = __webpack_public_path__ + "8a7100e9bcf0bb17f79dcb5b41776a64.svg";